export default __webpack_public_path__ + "static/media/f3.deefe58e.svg";